import { useTrEnumNamespace as e } from "./useTrEnumNamespace.mjs";
//#region src/enums/useTrBlockReasonCategory.ts
var t = () => e("blockReasonCategory");
//#endregion
export { t as useTrBlockReasonCategory };
